import { BootSplash } from "@/components/offline/boot-splash";
import { flushSync } from "react-dom";
import { root } from "./vars";

export const renderSplash = () => {
  // Commit the web splash before asking the native shell to hide its splash.
  // This avoids exposing an empty WebView during the handoff.
  flushSync(() => {
    root.render(<BootSplash />);
  });
};
